import { getCDNImageUrl } from '@dkrm/general-libs/Utils/imageUtils';
import { BASE_URL_ICON } from './constants';
export const generateUrlIcon = iconPath => getCDNImageUrl(`${BASE_URL_ICON + iconPath}.svg`);
export default {};